export default {"src":"/_next/static/media/arrowRightTab.51fa943f.svg","height":21,"width":24,"blurWidth":0,"blurHeight":0};